import React from 'react';

import { ExecutionHistoryContext } from '@qality/common-components/src/lib/ExecutionHistoryProvider';

import { TextExecutionDetailsView } from './TextExecutionDetails.view';

export const TextExecutionDetails = (): JSX.Element => {
  const { historyDetails } = React.useContext(ExecutionHistoryContext);

  return (
    <TextExecutionDetailsView
      executionsCount={historyDetails.executionsCount}
      executionsHistoryUrl={historyDetails.executionsHistoryUrl}
      previousExecution={historyDetails.previousExecution}
      previousExecutionUrl={historyDetails.previousExecutionUrl}
      previousExecutionStatus={historyDetails.previousExecutionStatus}
      lastFailedExectution={historyDetails.lastFailedExectution}
    />
  );
};
